import { defineMessages } from 'react-intl';

import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import cover from 'components/market/assets/manager-sales.jpg';
import { useCurrentMarketplaceUserContext } from 'contexts/currentMarketplaceUser';

import { OneTimeOnboardingDialog as OnboardingDialog } from '..';

const messages = defineMessages({
  title: {
    id: 'SalesOnboardingDialog.title',
    defaultMessage: 'Manager Sales',
  },
  description: {
    id: 'SalesOnboardingDialog.description',
    defaultMessage:
      'Scout the next superstar and buy player cards directly from other Sorare Managers',
  },
});

export const ManagersSales = () => {
  const { boughtSingleSaleTokenOffers } = useCurrentMarketplaceUserContext();

  return (
    <OnboardingDialog
      title={messages.title}
      description={messages.description}
      img={cover}
      lifecycleKey={LIFECYCLE.sawManagersSalesOnboarding}
      show={boughtSingleSaleTokenOffers?.hasAny === false}
    />
  );
};
